

































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IDocumentPage } from '@/types/document-page';
import Button from '@/components/Button.vue';
import { EDocumentPageType } from '@/enums/document-page-type';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Button,
    Icon,
  },
})
export default class FieldMoveItem extends Vue {
  @Prop() page: IDocumentPage;
  @Prop() currentPageId: string;
  @Prop() flipped: boolean;

  EDocumentPageType = EDocumentPageType;

  get thumbTooltip(): string {
    const url: string = this.page.thumbUrl;
    return `<img class="field-move-thumb-tooltip" src="${url}" width="200" style="background:white" />`;
  }

  get isCurrentPage(): boolean {
    return this.currentPageId === this.page.id;
  }

  get isDocumentContentType(): boolean {
    return this.page.pageType === EDocumentPageType.DocumentContent;
  }

  get disabled(): boolean {
    return this.isCurrentPage || !this.isDocumentContentType || !!this.page.loading;
  }

  handleClick() {
    this.$emit('click', this.page.id);
  }
}
